import { ResultItem } from '../../../../@types/flow';
import Loading from '../../../../Components/Loading';
import dateFormatToBR from '../../../../utils/dateFormat';
import NotFound from '../NotFound';
import Status from '../Status';
import { CustomTable } from './style';

interface TableFlowProps {
  results: ResultItem[];
  loading: boolean;
}

const TableFlow = ({ results, loading }: TableFlowProps) => {

  return (
    <CustomTable responsive="md">
      <thead className="table-header">
        <tr>
          <th>Status</th>
          <th>Modelo</th>
          <th>data de criação</th>
          <th>serviço</th>
          <th>órgão</th>
          <th>título</th>
        </tr>
      </thead>
      <tbody className="table-body">
        {loading ? (
          <tr>
            <td colSpan={7}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '850px' }}>
                <Loading />
              </div>
            </td>
          </tr>
        ) : results && results.length > 0 ? (
          results.map((item) => (
            <tr key={item.slug}>
              <td><Status type={item.ativo.toString()} /></td>
              <td><Status mode='yesNo' type={item.modelo.toString()} /></td>
              <td>{dateFormatToBR(item.created_at, true)}</td>
              <td>{item.servico_titulo ? item.servico_titulo : 'Serviço não vinculado'}</td>
              <td>{item.orgao_nome ? item.orgao_nome : 'Órgão não registrado'}</td>
              <td>{item.titulo}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>
              <NotFound />
            </td>
          </tr>
        )}
      </tbody>
    </CustomTable>
  );
};

export default TableFlow;